const uniqueId = 'uniqueId';
const image = 'image';
const richText = 'richText';
const text = 'text';
const textarea = 'textarea';
const number = 'number';
const date = 'date';
const signature = 'signature';
const list = 'list';
const user = 'user';
const chart = 'chart';
const inputGroup = 'inputGroup';
const block = 'block';

const multiSelect = 'multiSelect';
const multiSelectOption = 'multiSelectOption';

const dropdown = 'dropdown';
const dropdownOption = 'dropdownOption';

const table = 'table';
const tableCell = 'tableCell';
const tableCellOption = 'tableCellOption';

const types = {

  uniqueId,
  image,
  richText,
  text,
  block,
  textarea,
  number,
  date,
  signature,
  list,
  user,
  chart,
  inputGroup,

  multiSelect,
  multiSelectOption,

  dropdown,
  dropdownOption,

  table,
  tableCell,
  tableCellOption

};

types.all = Object.keys(types);

export default types;
